enum AbaTypeGroupEnum {
    RepaymentPrincipal = 'REPAYMENT_PRINCIPAL',
    SellInPrepaidInterest = 'SELL_IN_PREPAID_INTEREST',
}

export default AbaTypeGroupEnum;